<ng-container *transloco="let t; prefix: 'sidebar'">
  @let trip = tripResource.value();
  <aside class="sidebar-shell flex flex-col h-full min-h-0">
    <div class="sidebar flex-1">
      <div #scrollPort class="sidebar-scroll-port">
        <div
          #scrollRegion
          class="sidebar-scroll-content"
          [class.sidebar-scroll-content--padded]="scrollAffordance().showBottomHint"
        >
          <div #scrollBody class="sidebar-scroll-body">
      <div class="sidebar-header">
        <div class="logo">
          <img [src]="brandAssets.markOnDark" alt="Pelican" class="pelican-logo">
          <span class="logo-text">{{ t('pelican-account') }}</span>
        </div>
      </div>

      <app-impersonation-banner placement="sidebar" />

      <app-acting-as-banner placement="sidebar" />

      <!-- Trip Card -->
      <div class="trip-card" (click)="openLocationSwap()"
        [style.background-image]="'url(assets/images/locations/' + trip?.locId + '.jpg)' + ', url(assets/images/costa_rica_background.png)' ">
        <div class="trip-card-overlay"></div>
        <div class="trip-card-content">
          <h3>{{ trip?.locationName | uppercase }}</h3>
          <p>{{ trip?.tripDate | date:'MMMM d, yyyy' }}</p>
        </div>
        <div class="trip-card-badge">{{ daysUntilTrip() }} {{ t('days-away') }}</div>
        <div class="trip-card-shuffle">
          <fa-icon [icon]="['far', 'swap']" />
        </div>
      </div>

      @if (trip && showPublicTripLink()) {
      <div class="flex justify-between border border-gray rounded-md p-2 mb-2 font-mono items-center">
        <div class=" flex gap-2 items-center">
          <span class="text-gray-200 text-xs ">TRIP URL</span>
          <span>ppm.org/{{ trip.id }}</span>
        </div>
        <div class="flex gap-3 items-center">
          <button
            type="button"
            id="copy-trip-url-toast"
            class="text-gray-200 text-md cursor-pointer bg-transparent"
            [attr.aria-label]="t('copy-trip-url')"
            (click)="copyTripUrl()"
          >
            <fa-icon [icon]="['far', 'copy']" aria-hidden="true" />
          </button>
          <button
            type="button"
            class="text-gray-200 text-md cursor-pointer bg-transparent"
            [attr.aria-label]="t('trip-qr')"
            (click)="openTripQr()"
          >
            <fa-icon [icon]="['far', 'qrcode']" aria-hidden="true" />
          </button>
        </div>
      </div>
      } @else if (trip && nav.isGl()) {
      <p class="border border-gray rounded-md p-2 mb-2 text-xs text-gray-200" data-testid="trip-link-not-live">
        {{ t('trip-link-not-live', { tripId: trip.id }) }}
      </p>
      }

      <!-- Navigation -->
      <nav class="main-nav">
        <a routerLink="/dashboard" routerLinkActive="active" class="nav-item" data-page="dashboard">
          <fa-icon [icon]="navIcons.dashboard" class="nav-icon" />
          <span>{{ t('home') }}</span>
        </a>
        @if (hasTripNav()) {
        <a routerLink="/forms" routerLinkActive="active" class="nav-item" data-page="forms">
          <fa-icon [icon]="navIcons.forms" class="nav-icon" />
          <span>{{ t('forms') }}</span>
        </a>
        <a routerLink="/prep-planning" routerLinkActive="active" class="nav-item" data-page="prep-planning">
          <fa-icon [icon]="navIcons['prep-planning']" class="nav-icon" />
          <span>{{ t('prep-planning') }}</span>
        </a>
        <a routerLink="/trip-info" routerLinkActive="active" class="nav-item" data-page="trip-info">
          <fa-icon [icon]="navIcons['trip-info']" class="nav-icon" />
          <span>{{ t('trip-info') }}</span>
        </a>
        @if (nav.showDesktopPaymentPanel()) {
        <button type="button" class="nav-item w-full text-left bg-transparent border-0" (click)="openPaymentPanel()">
          <fa-icon [icon]="navIcons.payment" class="nav-icon" />
          <span>{{ t('make-payment') }}</span>
        </button>
        }
        }
      </nav>

      @if (showLeaderToolsSection()) {
      <div class="group-leader-tools">
        <div class="glt-header">
          <span>{{ t('group-leader-tools') }}</span>
        </div>
        <div class="glt-menu">
          @if (nav.showGroupManagementNav()) {
          <a routerLink="/group-management" routerLinkActive="active" class="glt-item" data-page="group-management">
            <fa-icon [icon]="navIcons['group-management']" class="glt-icon" />
            <span>{{ t('group-management') }}</span>
          </a>
          }
          @if (nav.showTripFinancesNav() && nav.canAccessTripFinances()) {
          <a routerLink="/trip-finances" routerLinkActive="active" class="glt-item" data-page="trip-finances">
            <fa-icon [icon]="navIcons['trip-finances']" class="glt-icon" />
            <span>{{ t('trip-finances') }}</span>
          </a>
          }
        </div>
      </div>
      }

        </div>
          </div>
        <app-sidebar-scroll-affordance
          [state]="scrollAffordance()"
          (pageDown)="onScrollAffordancePageDown()"
        />
      </div>
    </div>
    <div class="sidebar-bottom-section" id="navigation-footer" [class.expanded]="footerExpanded()">
      <!-- Search -->
      <!-- <div class="search-container search-sticky">
        <input type="text" placeholder="Search" class="search-input">
        <fa-icon [icon]="['far', 'search']" class="search-icon" />
      </div> -->

      <!-- Expand/Collapse Toggle -->
      <button class="footer-toggle" (click)="toggleFooter()" [attr.aria-label]="t('toggle-footer')">
        <fa-icon [icon]="['far', 'user']" class="footer-toggle-icon-collapsed" aria-hidden="true" />
        <fa-icon [icon]="['far', 'chevron-down']" class="footer-toggle-icon-expanded" aria-hidden="true" />
      </button>

      <!-- User Profile -->
      <div class="user-profile footer-collapsible">
        <div class="profile-pic-circle group overflow-hidden" (click)="openProfilePanel()">
          @if (showSidebarProfilePhoto()) {
            <img
              [src]="authUser()!.profilePhotoUrl"
              alt=""
              aria-hidden="true"
              class="w-full h-full object-cover transition-opacity duration-300 ease-in-out group-hover:opacity-30"
              (error)="onSidebarProfilePhotoError()"
            />
          } @else {
            <fa-icon [icon]="navIcons.profile" class="profile-icon" />
          }
          <div class="profile-edit-overlay">
            <fa-icon [icon]="['far', 'edit']" />
          </div>
        </div>
        <div class="profile-info">
          <div class="profile-name">
            <span>{{ authUser()?.displayName || t('profile-name-placeholder') }}</span>
          </div>
        </div>
      </div>

      <!-- Icon Menu (Horizontal) -->
      <div class="icon-menu">
        @if (nav.showSquawksNav()) {
        <button
          type="button"
          class="icon-menu-item text-primary dark:text-primary-text"
          (click)="openSquawks()"
          [attr.aria-label]="t('squawks')"
          [title]="t('squawks')"
        >
          <fa-icon [icon]="navIcons.squawks" aria-hidden="true" />
          @if (squawksUnreadCount() > 0) {
          <span class="notification-dot" [attr.aria-label]="t('squawks-unread', { count: squawksUnreadCount() })"></span>
          }
        </button>
        }
        @if (nav.showChatterNav()) {
        <button
          type="button"
          class="icon-menu-item text-primary dark:text-primary-text"
          (click)="openChatter()"
          [attr.aria-label]="t('chatter')"
          [title]="t('chatter')"
        >
          <fa-icon [icon]="navIcons.chatter" aria-hidden="true" />
          @if (chatterUnreadCount() > 0) {
          <span class="notification-dot" [attr.aria-label]="t('chatter-unread', { count: chatterUnreadCount() })"></span>
          }
        </button>
        }
      </div>

      <!-- Settings & Logout -->
      <div class="sidebar-footer footer-collapsible">
        <button
          class="footer-icon-btn text-primary dark:text-primary-text"
          id="sidebar-accessibility-trigger"
          [attr.aria-label]="t('accessibility-options')"
          [title]="t('accessibility-options')"
        >
          <fa-icon [icon]="['far', 'universal-access']" aria-hidden="true" />
        </button>
        <ion-popover trigger="sidebar-accessibility-trigger" triggerAction="click" dismissOnSelect="false">
          <ng-template>
            <div class="p-4">
              <h2 class="mb-2 text-sm font-semibold text-primary-text">{{ t('accessibility-options') }}</h2>
              <app-accessibility-settings />
            </div>
          </ng-template>
        </ion-popover>
        <button
          class="footer-icon-btn text-primary dark:text-primary-text"
          (click)="toggleDarkMode()"
          [attr.aria-label]="t('toggle-dark-mode')"
          [title]="t('toggle-dark-mode')"
        >
          @if (isDarkMode()) {
          <fa-icon [icon]="['far', 'sun']" aria-hidden="true" />
          } @else {
          <fa-icon [icon]="['far', 'moon']" aria-hidden="true" />
          }
        </button>
        <button type="button" class="footer-item" (click)="logout()">
          <fa-icon [icon]="['far', 'right-from-bracket']" class="footer-icon" />
          <span>{{ t('log-out') }}</span>
        </button>
      </div>
    </div>
  </aside>
</ng-container>
